// Sai Maheshwar 11/11/2022 3031689933  integrated locked process
// dilip 01/26/2023 3031689933 Add lock account check functionality
// Guru Prasad 06/23/1013 3031593925 Added Locked user name in the toast message

import {createSlice} from '@reduxjs/toolkit';
import {httpGet} from '../../util/Rest';
import {ACCOUNTSUMMARY} from '../../constants/MicroServiceConstants';

const initialData = {
  accountSummaryData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  lockedAccountStatus: null,
  lockStatus: null,
  lockUser: null,
  accountLockedStatus: false,
  lockedByUser: null,
  accountLocked: null,
  lockedAccountNumber: null,
};

const slice = createSlice({
  name: 'accountSummary',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchAccountSummaryData: (state, action) => {
      if (action?.payload?.accountStatus) {
        state.accountSummaryData = {};
      } else {
        state.accountSummaryData = action.payload;
      }      
      state.isLoading = false;
      state.errorMsg = null;
      if (state.lockedAccountStatus !== false) {
        state.lockedAccountStatus = action.payload.accountStatus;
      }
      state.lockUser = action.payload.lockUser;
      state.lockedAccountNumber = action.payload.accountNumber;
    },
    getLockedStatus: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.lockStatus = action.payload.accountStatus;
    },
    getLockedInfo: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.accountLockedStatus = action.payload.accountStatus;
      state.lockedByUser = action.payload.lockUser;
      state.accountLocked = action.payload.accountNumber;
      state.accountSummaryData = action.payload;
    },
    resetLockedStatus: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.accountLockedStatus = false;
      state.lockedByUser = null;
      state.accountLocked = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetData: (state) => {
      state.accountSummaryData = {};
      state.isLoading = false;
      state.lockedAccountNumber = null;
    },
    resetLockAccountStatus: (state) => {
      state.lockedAccountStatus = null;
      state.isLoading = false;
      state.lockStatus = null;
    },
    resetDataAndStatus: (state) => {
      state.isLoading = false;
      state.lockedAccountStatus = null;
      state.accountSummaryData = {};
      state.lockedAccountNumber = null;
      state.errorMsg = null;
      state.successMsg = null;
      state.lockStatus = null;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchAccountSummaryData,
  fetchStart,
  fetchError,
  resetData,
  resetLockAccountStatus,
  resetDataAndStatus,
  getLockedStatus,
  getLockedInfo,
  resetLockedStatus,
} = slice.actions;

export const fetchAccountSummary = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${ACCOUNTSUMMARY}/find/${accountNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchAccountSummaryData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const getLockStatusInfo = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${ACCOUNTSUMMARY}/find/${accountNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getLockedStatus(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const getLockedAccountInfo = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${ACCOUNTSUMMARY}/find/${accountNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getLockedInfo(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const resetAccountSummaryData = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};

export const resetAccountLockStatus = () => {
  return (dispatch) => {
    dispatch(resetLockedStatus());
  };
};
